import {
  getServicesCookie,
  saveServicesArrayToCookie,
} from 'utils/services';
import { dispatchEvent } from 'utils/common';
import { logEvent } from '../helpers';
import { BASKET_EVENT_UPDATE_SERVICE } from '../consts';
import type { BasketSetServiceEventArg, ServiceCookie } from '../../../../../types/services';
import { servicesGuard } from '../../../../../types/guards';

function isBasketSetServicesEvent(e: Event): e is CustomEvent<BasketSetServiceEventArg[]> {
  if (!('detail' in e)) return false;

  if (!Array.isArray(e.detail)) return false;

  if (e.detail.length === 0) return false;

  return e.detail.every(item => servicesGuard(item as ServiceCookie));
}

export const handleBasketSetServices = (e: Event) => {
  if (isBasketSetServicesEvent(e)) {
    logEvent('basket:set_services', e.detail);

    const isSameServiceByIdentity = (left: ServiceCookie, right: ServiceCookie) =>
      left.code === right.code &&
      left.parentCode === right.parentCode &&
      left.configuratorId === right.configuratorId;

    let services = getServicesCookie() || [];

    e.detail.forEach(service => {
      if (service.quantity === 0) {
        services = services.filter(current => !isSameServiceByIdentity(current, service));
      } else {
        const existingServiceIndex = services.findIndex(current =>
          isSameServiceByIdentity(current, service)
        );

        if (existingServiceIndex >= 0) {
          services[existingServiceIndex] = service;
        } else {
          services.push(service);
        }
      }
    });

    saveServicesArrayToCookie(services);

    dispatchEvent(BASKET_EVENT_UPDATE_SERVICE, services);
  } else {
    console.error('Invalid arguments in basket:set_services event');
  }
};
